module.exports = __webpack_public_path__ + "img/gitlab.f995de7a.svg";